var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"header"},[_vm._v("Hello World")]),_c('mock-chart'),_c('score-chart',{attrs:{"chart-data":_vm.barData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }